import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleContextService } from '../../core/services/role-context.service';
import { RolPlataforma } from '../../core/models/novedades.models';
import { AccessibilityToolbar } from '../../shared/components/accessibility-toolbar/accessibility-toolbar';
import { BreadcrumbItem, Breadcrumbs } from '../../shared/components/breadcrumbs/breadcrumbs';
import { HeaderNotificationBell } from '../../shared/components/header-notification-bell/header-notification-bell';
import { UserSessionSummary } from '../../shared/components/user-session-summary/user-session-summary';
import { SidebarMenu } from '../../shared/sidebar-menu/sidebar-menu';
import { ActualizacionesPanel } from './components/actualizaciones-panel/actualizaciones-panel';
import { roleHasNotifications, routeForRole } from '../../core/utils/roles.util';

@Component({
  selector: 'app-actualizaciones',
  imports: [
    CommonModule,
    SidebarMenu,
    ActualizacionesPanel,
    HeaderNotificationBell,
    AccessibilityToolbar,
    Breadcrumbs,
    UserSessionSummary,
  ],
  templateUrl: './actualizaciones.html',
  styleUrl: './actualizaciones.css',
})
export class Actualizaciones {
  readonly breadcrumbs: BreadcrumbItem[] = [{ label: 'Inicio', link: '/principal' }, { label: 'Notificaciones' }];
  rol: RolPlataforma = 'postulante';

  get notificacionesDisponibles(): boolean {
    return roleHasNotifications(this.rol);
  }

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly roleContext: RoleContextService
  ) {
    this.route.queryParamMap.subscribe((params) => {
      this.rol = this.roleContext.resolveRole(params, this.rol);
      this.redirigirSiNoAplica();
    });
  }

  private redirigirSiNoAplica(): void {
    if (this.notificacionesDisponibles) return;

    this.router.navigate([routeForRole(this.rol)], {
      queryParams: { role: this.rol },
      replaceUrl: true,
    });
  }
}
